function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _path, _g;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgGeolocatedOpportunities = function SvgGeolocatedOpportunities(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 144,
    fill: "none",
    viewBox: "0 0 168 144"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("mask", {
      id: "a",
      width: 134,
      height: 104,
      x: 17,
      y: 20,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "luminance"
      },
      children: _path || (_path = /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M150.352 20.894H17.647v102.212h132.705z"
      }))
    }), _g || (_g = /*#__PURE__*/_jsxs("g", {
      mask: "url(#a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "m84.134 90.158-.001.003a1.03 1.03 0 0 0 .614 1.318l6.106 2.222a1.03 1.03 0 0 0 1.318-.614l.001-.003a1.03 1.03 0 0 0-.614-1.318l-6.106-2.222a1.03 1.03 0 0 0-1.318.614"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M86.45 93.669a5.454 5.454 0 0 1-5.422-4.97l-1.636-18.37-22.906-9.83a5.452 5.452 0 1 1 4.301-10.018L86.7 61.589a5.45 5.45 0 0 1 3.272 4.534l1.917 21.61a5.454 5.454 0 0 1-4.956 5.904z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#006716",
        d: "m42.867 97.813-23.981 7.79c-4.302-13.232 2.939-27.446 16.172-31.747l.017-.005a23.7 23.7 0 0 1 7.791-1.246z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#008A21",
        d: "M42.867 97.813 28.05 118.208c-4.503-3.272-7.433-7.307-9.162-12.605z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#00D639",
        d: "m42.867 97.813 23.981-7.79c4.304 13.24-2.942 27.463-16.184 31.767l-.006.001c-7.946 2.586-15.847 1.34-22.61-3.583z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#00460C",
        d: "M42.867 97.813V72.605c11.141 0 20.537 6.823 23.981 17.418zM125.045 81.5v-8.818c-11.141 0-20.537 6.825-23.981 17.42l8.43 2.741a16.425 16.425 0 0 1 15.551-11.342"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#00D639",
        d: "M108.701 97.89c0-1.713.266-3.416.794-5.047l-8.429-2.742a24 24 0 0 0-1.231 7.79c-.01 13.913 11.266 25.199 25.18 25.209h.031v-8.819c-9.034-.026-16.345-7.357-16.345-16.39"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#00AF2D",
        d: "M125.094 114.281h-.047v8.819a24 24 0 0 0 7.791-1.231l-2.727-8.367a16.6 16.6 0 0 1-5.017.779"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#006716",
        d: "m130.109 113.502 2.727 8.367c5.298-1.714 9.334-4.643 12.606-9.161l-7.105-5.157a16.43 16.43 0 0 1-8.228 5.951M145.443 83.074l-7.105 5.157a16.39 16.39 0 0 1 0 19.32l7.105 5.157c6.545-9.006 6.545-20.629 0-29.634"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#008A21",
        d: "M125.094 81.5a16.4 16.4 0 0 1 13.244 6.731l7.106-5.157c-4.909-6.761-12.045-10.392-20.397-10.392v8.819z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#303030",
        d: "M81.214 96.754h-.171a1.36 1.36 0 0 1-.95-.608L59.803 63.693a1.29 1.29 0 0 1-.03-1.34c.231-.42.672-.683 1.152-.686h.016l54.241.655a1.324 1.324 0 0 1 .888 2.29L82.118 96.396a1.34 1.34 0 0 1-.904.358M63.342 64.347l18.153 29.01 30.354-28.433z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#303030",
        d: "M43.193 98.265c-.47 0-.902-.248-1.137-.654a1.29 1.29 0 0 1-.016-1.325l22.095-39.62a1.324 1.324 0 1 1 2.306 1.278L45.452 95.6l39.688-.172c.73 0 1.324.594 1.324 1.325.01.722-.57 1.314-1.293 1.324h-.016zM125.14 99.106a1.34 1.34 0 0 1-1.278-.966l-14.46-51.492H99.336a1.326 1.326 0 0 1 0-2.649h11.079a1.34 1.34 0 0 1 1.278.966l14.725 52.459a1.34 1.34 0 0 1-.92 1.636z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#B26E3D",
        d: "m98.875 42.737-8.281.449a2.164 2.164 0 0 0-2.044 2.278v.001a2.164 2.164 0 0 0 2.278 2.044l8.281-.448a2.164 2.164 0 0 0 2.044-2.278v-.002a2.165 2.165 0 0 0-2.278-2.044"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C6C6C6",
        d: "M83.364 50.247a4.66 4.66 0 0 1-3.911-2.119L71.35 35.726a4.678 4.678 0 0 1 7.838-5.11l6.685 10.252 7.167-.094h.063a4.674 4.674 0 1 1 .046 9.348l-9.723.125z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "m81.009 100.993-.001.003a1.03 1.03 0 0 0 .614 1.318l6.106 2.222a1.03 1.03 0 0 0 1.318-.615l.001-.003a1.03 1.03 0 0 0-.614-1.318l-6.106-2.222a1.03 1.03 0 0 0-1.318.615"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M82.446 104.263a5.467 5.467 0 0 1-5.454-5.22l-1.153-26.61L55.193 60.64a5.454 5.454 0 1 1 5.407-9.473l23.264 13.29a5.47 5.47 0 0 1 2.742 4.487L87.9 98.561a5.47 5.47 0 0 1-5.22 5.687z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#B26E3D",
        d: "M74.887 25.568a2.104 2.104 0 1 0 3.023-2.663l-3.023 2.665z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M77.879 22.888a2.104 2.104 0 0 0-2.992 2.68l3.023-2.664zM75.06 22.608a.857.857 0 1 0 0-1.714.857.857 0 0 0 0 1.714"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C6C6C6",
        d: "M79.064 41.57c1.31-1.793.717-1.419.873-3.88.11-1.62.499-3.74.016-5.329-1.901-6.232-11.11-5.36-15.41-.483-3.928 4.425-7.512 9.255-9.74 14.77-1.06 2.586-2.119 5.126-.56 7.728 1.324 2.243 3.942 3.63 6.512 3.724 1.59.062 3.164-.5 4.535-1.31 5.765-3.474 9.879-9.908 13.774-15.22"
      })]
    }))]
  }));
};
export default SvgGeolocatedOpportunities;